module.exports = __webpack_public_path__ + "img/thumbnail_SnowLeopard_j_normal.f4d49d87.png";